import React from "react";
import { BsChevronRight, BsChevronLeft } from "react-icons/bs";
import { Button } from "react-bootstrap";
const Pagination = (props) => {
  const { previousUrl, nextUrl, changePage } = props;

  return (
    <div className="d-flex justify-content-end">
      <Button
        disabled={!previousUrl}
        className="me-2 d-flex align-items-center"
        variant={previousUrl ? "outline-dark" : "outline-gray-400"}
        onClick={() => changePage("prev")}
        value={previousUrl}
      >
        <BsChevronLeft />
      </Button>
      <Button
        disabled={!nextUrl}
        className="d-flex align-items-center"
        variant={nextUrl ? "outline-dark" : "outline-gray-400"}
        onClick={() => changePage("next")}
        value={nextUrl}
      >
        <BsChevronRight />
      </Button>
    </div>
  );
};

export default Pagination;
